var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"note-box"},[_c('div',{staticClass:"note-box-top"},[_vm._v("笔记")]),_c('div',{staticClass:"note-content no-scroll-bar",domProps:{"innerHTML":_vm._s(this.noteContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }